<!--
 * @Author: lishiqiao
 * @Date: 2022-03-09 10:41:26
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-03-10 11:01:16
-->
<template>
  <!-- 养成收获概览产量 -->
  <div class="page-list">
    <!-- 汇总表-养成 -->
    <SummaryPage v-if="pageType === 'summary'" @getPageType="getPageType" />
    <!-- 明细表-养成 -->
    <DetailPage v-if="pageType === 'detail'" @getPageType="getPageType" />
  </div>
</template>

<script>
import SummaryPage from "./yc-harvest-output-summary.vue";
import DetailPage from "./yc-harvest-output-detail.vue";
export default {
  name: "yc-harvest",
  data() {
    return {
      pageType: "summary", // summary汇总表,detail明细表
    };
  },
  computed: {},
  methods: {
    getPageType(pageType) {
      this.pageType = pageType;
    },
  },
  components: {
    SummaryPage,
    DetailPage,
  },
};
</script>

<style lang="less" scoped>
</style>